import SpotifyEmbed from "@jesus-central-church/ui/src/components/media/spotify-embed";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbSpotifyEmbed } from "@storyblok/types/287435740670216/storyblok-components";

export function SpotifyEmbedComponent({ blok }: { blok: SbSpotifyEmbed }) {
  const spotifyUrl = blok.spotifyUrl?.url;

  return (
    <SpotifyEmbed
      {...storyblokEditable(blok as SbBlokData)}
      spotifyUrl={spotifyUrl}
    />
  );
}
